var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullEncryptionSolIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083",
    transform: "translate(-788 -1857)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(788 1857)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(746.367 1867.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3452",
    "data-name": "Path 3452",
    d: "M96.911,16.454c1.488-.333,3.276-.669,5.286-.926v-3.29a6.952,6.952,0,1,1,13.9,0v3.29c2.009.257,3.8.593,5.286.926V12.238a12.238,12.238,0,0,0-24.476,0Z",
    transform: "translate(-37.516)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3453",
    "data-name": "Path 3453",
    d: "M238.707,319.33a1.441,1.441,0,1,0,1.441,1.441A1.443,1.443,0,0,0,238.707,319.33Z",
    transform: "translate(-167.074 -294.765)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454",
    "data-name": "Path 3454",
    d: "M71.633,225.985a54.661,54.661,0,0,0-15.364,2.281V245.7a52.869,52.869,0,0,0,30.729,0V228.267A54.808,54.808,0,0,0,71.633,225.985Zm1.154,12.188v3.787H70.479v-3.787a3.749,3.749,0,1,1,2.308,0Z",
    transform: "translate(0 -208.601)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullEncryptionSolIcon);
export default __webpack_public_path__ + "static/media/full-encryption-sol-icon.c7d1fa984574ce1bca4c51429144c33d.svg";
export { ForwardRef as ReactComponent };